import classNames from 'classnames/bind';
import styles from './ProjectItem.module.scss';
import { NavLink } from 'react-router-dom';

import routes from '~/configs';
import { BASE_URL_IMG } from '~/helper/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useContext } from 'react';
import { LoginContext } from '../Context/LoginProvider';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import EditProject from '../EditProject/EditProject';
import Controller from '../Controller';

const cx = classNames.bind(styles);

function ProjectItem({ data, handleRemove }) {
  const { loginStatus } = useContext(LoginContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const handleEditClick = () => setModalComponentContent(<EditProject id={data.id} />);
  const handleRemoveClick = (e) => {
    handleRemove(e, data.id);
  };

  return (
    <div className={cx('project-item')}>
      {loginStatus && (
        <Controller className={cx('controller')} handleEdit={handleEditClick} handleDelete={handleRemoveClick} />
      )}
      <NavLink to={`${routes.projectDetail}/${data.id}`}>
        <img alt="" src={BASE_URL_IMG + data.image} />
        <h6>{data.name}</h6>
        <span>{data.descriptions}</span>
      </NavLink>
      <a className={cx('link')} href={data.github_link} target='_blank'>
        Visit now
      </a>
    </div>
  );
}

export default ProjectItem;
